module.exports = __webpack_public_path__ + "media/images/solo-100-new-450c12add371a3bdbb4b195dff10d343.webp";